import { render, staticRenderFns } from "./WorksRotation.vue?vue&type=template&id=b52cc19e&scoped=true"
import script from "./WorksRotation.vue?vue&type=script&lang=js"
export * from "./WorksRotation.vue?vue&type=script&lang=js"
import style0 from "./WorksRotation.vue?vue&type=style&index=0&id=b52cc19e&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b52cc19e",
  null
  
)

export default component.exports